<div
  class="w-56 self-stretch px-4 py-2.5 bg-slate-900 bg-opacity-80 rounded-lg backdrop-blur-sm justify-start items-center gap-2.5 flex"
>
  <div
    class="text-stone-50 text-base font-normal font-['Poppins'] leading-tight"
  >
    {{ text }}
  </div>
</div>
